import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Logo from "../Components/Layout/Logo";
import { Link } from "react-router-dom";

//Material Ui Stuffs
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";

//Redux Stuff
import { connect } from "react-redux";
import { signUpUser } from "../redux/actions/userActions";

// Hooks Stuff
import { usePrevious } from "../util/customHooks";

const styles = {
  root: {
    flexGrow: 1,
    textAlign: "center",
    padding: "1rem",
  },

  mainForm: {
    width: "auto",
  },

  pageTitle: {
    margin: "10px auto 10px auto",
    fontWeight: "bold",
  },

  textField: {
    margin: "10px auto 10px auto",
    width: "90%",
  },

  button: {
    marginTop: 20,
    position: "relative",
    width: "90%",
    color: "#fff",
  },

  customError: {
    color: "red",
    fontSize: "0.8rem",
    marginTop: 10,
  },

  progress: {
    position: "absolute",
  },
};

const SignUp = (props) => {
  const {
    classes,
    history,
    signUpUser,
    UI: { loading },
  } = props;

  //Hooks
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [username, setUsername] = useState("");
  const [errors, setError] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const newUserData = {
      email,
      password,
      confirmPassword,
      username,
    };

    signUpUser(newUserData, history);
  };

  const previousError = usePrevious(errors);
  const newErrors = props.UI.errors;

  useEffect(() => {
    if (previousError !== newErrors) {
      setError(newErrors);
    }
  }, [previousError, newErrors]);

  return (
    <Grid container className={classes.root} justify="center">
      <Grid item sm={4}>
        <Logo />
        <Typography variant="h4" className={classes.pageTitle}>
          Create your account
        </Typography>
        <form className={classes.mainForm} noValidate onSubmit={handleSubmit}>
          <TextField
            id="username"
            name="username"
            type="text"
            label="Username"
            placeholder="e.g.John Doe"
            className={classes.textField}
            helperText={errors.username}
            error={errors.username ? true : false}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <TextField
            id="email"
            name="email"
            type="email"
            label="Email"
            placeholder="e.g.you@yourgmail.com"
            className={classes.textField}
            helperText={errors.email}
            error={errors.email ? true : false}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <TextField
            id="password"
            name="password"
            type="password"
            label="Password"
            placeholder="At least 6 characters"
            className={classes.textField}
            helperText={errors.password}
            error={errors.password ? true : false}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            variant="outlined"
          />
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            label="Confirm Password"
            placeholder="At least 6 characters"
            className={classes.textField}
            helperText={errors.confirmPassword}
            error={errors.confirmPassword ? true : false}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            variant="outlined"
          />
          {errors.general && (
            <Typography variant="body2" className={classes.customError}>
              {errors.general}
            </Typography>
          )}
          <Typography variant="body2">
            By clicking signup,you agree to our{" "}
            <Link to="/en/terms">Terms of Use</Link>.
          </Typography>
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={loading}
          >
            Sign Up
            {loading && (
              <CircularProgress size={30} className={classes.progress} />
            )}
          </Button>
          <br />
          <br />
          <small>
            Already have an account? Login{" "}
            <Link style={{ color: "#2942ce" }} to="/login">
              here
            </Link>
          </small>
        </form>
      </Grid>
    </Grid>
  );
};

SignUp.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

const mapActionsToProps = {
  signUpUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(SignUp));

// Give a user feedback after they've signed up with material-ui snackbars,you can read more about it through this
//link: https://material-ui.com/components/snackbars/
